import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';
import { IAppointment } from '../types/appointment_interfaces';
import { CancellationReasonsDatasource } from './../datasources/cancellation_reasons_datasource';

angular
  .module('capability-ng-appointments')
  .factory(
    'loadCancellationReasonsCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsCommandServant: AppointmentsCommandServant,
      log: any,
      ngCancellationReasonsDatasource: CancellationReasonsDatasource
    ): ICommand => {
      return defineCommand(
        'loadCancellationReasonsCommand',
        (deferred: ng.IDeferred<any>, appointmentId: number, calendarInstanceId: number): void => {
          ngAppointmentsCommandServant
            .request({
              url: 'cancel_reasons',
              method: 'GET',
              params: { calendar_instance_id: calendarInstanceId }
            })
            .then(
              ({ data }: ng.IHttpPromiseCallbackArg<any>) => {
                ngCancellationReasonsDatasource.write(data);
                deferred.resolve(QueryMediator.runQueries(ngCancellationReasonsDatasource));
              },
              () => {
                log.error('Unable to load cacellation reasons');
                deferred.reject();
              }
            );
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/load_cancellation_reasons.ts